export function clearState (state) {
  state.user = []
  sessionStorage.clear()
}

export function clearOrderPayment (state) {
  state.order_data = {
    'host_code': '',
    'ar_code': '',
    'tax_rate': 7,
    'discount_word': '',
    'discount_amount': 0,
    'item_amount': 0,
    'bill_type': 0,
    'cash_amount': 0,
    'credit_card_amount': 0,
    'sub': []
  }
  state.item_subs = []
}

export function Loading (state) {
  state.isLoading = !state.isLoading
}



// WEBPACK FOOTER //
// ./src/vuex/mutation.js